import {
  Avatar,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Autodesk from 'assets/images/auth/autodesk.webp';
import Excel from 'assets/images/auth/excel.png';
import Redas from 'assets/images/auth/redas_result.webp';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';
import GoogleDrive from 'assets/images/auth/googledrive_result.webp';
import { useMigrationSchedule } from '../../hooks/useMigration';
import useMigrateStore from '../../store/useMigrate';

// const InfoRow = ({ label, value }) => (
//   <Stack direction="column" justifyContent="space-between">
//     <Typography variant="body2" color="text.secondary">
//       {label}
//     </Typography>
//     <Typography variant="body1" fontWeight={400}>
//       {value || '-'}
//     </Typography>
//   </Stack>
// );

function ScheduleFormDialog({ open, onClose, onConfirm, data }) {
  const { sourceProviderData, destinationProviderData, handleSourceProviderData, handleDestinationProviderData } = useMigrateStore();
  const { mutate: migrateDataSchedule, isPending: isMigrateDataSchedule } = useMigrationSchedule();
  //   const [scheduleName, setscheduleName] = useState('');
  //   const [timeInterval, setTimeInterval] = useState('');
  const formik = useFormik({
    initialValues: {
      scheduleName: '',
      timeInterval: ''
    },
    validationSchema: Yup.object({
      scheduleName: Yup.string().required('Schedule name is required'),
      timeInterval: Yup.string().required('Time interval is required')
    }),
    onSubmit: (values) => {
      handleSubmit(values); // pass data to parent
    }
  });
  console.log({ sourceProviderData, destinationProviderData });

  const handleSubmit = (val) => {
    const payload = {
      schedule_name: val.scheduleName,
      frequency: val.timeInterval,
      payload: data
    };
    onConfirm(payload)
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle fontWeight="bold">Schedule Extraction {data?.type.toUpperCase()}</DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Autodesk User
            </Typography>
            <Typography variant="body1" fontWeight={400}>
              {data?.connection_user_name || '-'}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Hub Name
            </Typography>
            <Typography variant="body1" fontWeight={400}>
              {data?.hub_name || '-'}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Project Name
            </Typography>
            <Typography variant="body1" fontWeight={400}>
              {data?.project_name || '-'}
            </Typography>
          </Stack>
        </Stack>

        <Divider sx={{ my: 3 }} />
        <form onSubmit={formik.handleSubmit}>
          <Stack spacing={2} mb={3}>
            <TextField
              label="Schedule Name"
              name="scheduleName"
              fullWidth
              required
              value={formik.values.scheduleName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.scheduleName && Boolean(formik.errors.scheduleName)}
              helperText={formik.touched.scheduleName && formik.errors.scheduleName}
            />

            <FormControl fullWidth error={formik.touched.timeInterval && Boolean(formik.errors.timeInterval)}>
              <InputLabel>Time Interval</InputLabel>
              <Select
                name="timeInterval"
                label="Time Interval"
                value={formik.values.timeInterval}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="HOURLY">Hourly</MenuItem>
                <MenuItem value="DAILY">Daily</MenuItem>
                <MenuItem value="WEEKLY">Weekly</MenuItem>
                <MenuItem value="MONTHLY">Monthly</MenuItem>
              </Select>
              <FormHelperText>{formik.touched.timeInterval && formik.errors.timeInterval}</FormHelperText>
            </FormControl>
          </Stack>

          <Button type="submit" sx={{ mt: 2, fontWeight: 'bold' }} fullWidth variant="contained">
            CONFIRM SCHEDULE
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default ScheduleFormDialog;
